import { render } from "./App.vue?vue&type=template&id=46a908c7"
const script = {}

import "./App.vue?vue&type=style&index=0&id=46a908c7&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__